<template>

    <div :class="!$BRT.$urlParam.share.status ? 'brt-map-poiInfoModule' : ' brt-map-poiInfoModule share'" v-if="show" ref="poiInfoModule">

        <div class="close-box" @click ="close" v-if="!$BRT.$filter.open && !$BRT.$active.initEnter && !$BRT.$urlParam.share.status">
            <div class="wrap">
                <i class="iconfont icon-close-02"></i>
            </div>
        </div>

        <div class="go-here" @click="getRoute">
            <i class="iconfont icon-route_01"></i>
            <p>到这去</p>
        </div>


        <div class="content-box" @click="goDetail">

            <div class="box title">
                <img :src="poiInfo.LOGO" alt="logo" v-if="poiInfo.LOGO">
                <span>{{poiInfo.NAME}}</span>
                <span>{{poiInfo.floorName}}层</span>
            </div>

            <!--分享地址-->
            <div class="box share-address" v-show="$BRT.$urlParam.share.status">
                <span>{{poiInfo.address}}</span>
                <span>查看详情</span>
            </div>



            <div class="box lnglat"  v-if="poiInfo.distance || poiInfo.lng || poiInfo.lat">
                <!--                <div class="wrap">-->

                <!--                    <span class="distance" v-if="poiInfo.distance">{{poiInfo.distance}}m</span>-->

                <!--                    <div class="box">-->
                <!--                        <span v-if="poiInfo.lng">longitude：{{poiInfo.lng}}</span>-->
                <!--                        <span v-if="poiInfo.lat">latitude：{{poiInfo.lat}}</span>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="l" v-if="poiInfo.distance">{{poiInfo.distance}} 米</div>
                <div class="r">
                    <span v-if="poiInfo.lng">经度：{{poiInfo.lng}}</span>
                    <span v-if="poiInfo.lat">纬度：{{poiInfo.lat}}</span>
                </div>
            </div>

            <!--距离及口碑-->
            <div class="box praise" v-if="poiInfo.praise.length || poiInfo.CATEGORY_NAME" v-show="!$BRT.$urlParam.share.status">
                <span v-if="poiInfo.CATEGORY_NAME">{{poiInfo.CATEGORY_NAME}}</span>
                <!--<img v-if="poiInfo.praise" v-for="(item,index) in poiInfo.praise" :src="item.icon" alt="评价" />-->

            </div>


            <!--活动-->
            <div class="box active" v-if="poiInfo.active.length>0 || (poiInfo.detail && poiInfo.detail.TAGS &&  poiInfo.detail.TAGS.length > 0)" v-show="!$BRT.$urlParam.share.status">

                <Tags class="tag" v-if="poiInfo.activity || poiInfo.detail || poiInfo.theme_activity" :data="poiInfo.poi" scroll></Tags>

                <!--<div class="l-box"> <span>活动&nbsp;{{poiInfo.active.length}}</span> </div>-->

                <!--<div class="r-box">-->
                    <!--<a v-for="(item,index) in poiInfo.label" :class="index <2 ? 'active':''" v-if="index<5">{{item.name}}</a>-->
                <!--</div>-->

            </div>


        </div>

        <div class="box btn-box" v-show="!$BRT.$urlParam.share.status">
            <!--<a class="back" v-if="$BRT.$filter.open || $BRT.$active.initEnter" @click="back"><i class="iconfont icon-back" ></i></a>-->
            <a @click="goDetail"><i class="iconfont icon-detail" ></i> 查看详情</a>
            <a @click="sharePoint"><i class="iconfont icon-share"></i> 分享位置</a>
        </div>

    </div>

</template>


<script>

    import {Tags} from '@/components/tags';

    import {_activityPoiExtend, _detailPoiExtend,CATEGORY_ICONExtend,_themeActivityPoiExtend} from "@/utils/search_poi_extend";
    import {getPoiInfo} from './../../brtmap/Brtmap.js';

    export default {
        name: "PoiInfoModule",

        components: {
            Tags
        },

        data(){
          return {
              show:false,

              needfloor:false,

              poiInfo:{

                  LOGO:'',
                  NAME:'',
                  floorName:'',
                  slideIMG:[],
                  distance:0,
                  address:'',
                  time:'',
                  tel:'',
                  praise:[],
                  label:[],
                  active:[],
                  //0即将开始 1进行中 type 0店铺活动 1主题活动
                  shopDetail:'',

                  activity:'',
                  detail:'',
                  lng:'',
                  lat:'',

                  CATEGORY_NAME:'',

                  // LOGO:'./images/poi_logo.png',
                  // NAME:'麦当劳',
                  // floorName:'F1',
                  // slideIMG:[],
                  // distance:100,
                  // address:'测试测试测试测',
                  // time:'周一到周五 09：00~24：00',
                  // tel:'023-000000',
                  // praise:[{icon:'./images/poi_icons_01.png',name:'商家推荐'},{icon:'./images/poi_icons_01.png',name:'商家推荐'},{icon:'./images/poi_icons_01.png',name:'商家推荐'},{icon:'./images/poi_icons_01.png',name:'商家推荐'},{icon:'./images/poi_icons_01.png',name:'商家推荐'}],
                  // label:['美食排行榜第一','美食排行榜第一'],
                  // active:[{type:0,name:'主题活动主题活动主题活动',state:0,endTime:'1天14时',imgUrl:'./images/u4324.png',num:1000},{type:1,name:'主题活动主题活动主题活动',state:0,endTime:'1天14时',imgUrl:'./images/u4324.png',num:1000},{type:1,name:'主题活动主题活动主题活动',state:0,endTime:'1天14时',imgUrl:'./images/u4324.png',num:1000},{type:1,name:'主题活动主题活动主题活动',state:0,endTime:'1天14时',imgUrl:'./images/u4324.png',num:1000}],
                  // //0即将开始 1进行中 type 0店铺活动 1主题活动
                  // shopDetail:'我是店铺介绍我是店铺介绍我是店铺介绍我是店铺介绍我是店铺介绍我是店铺介绍',
              },

              LastPOI_ID:'',        //筛选上一次插标对象
          }
        },

        created(){


            this.bus.$off('selectedPoint');
            this.bus.$on('selectedPoint',(res)=>{

                if(res){
                    this.$mapStep.type='selectePOI';
                    this.$mapStep.POI_ID = res;
                    this.showPoi(res);
                }

                else{this.$BRT.$marker.selected.empty()}
            })

            this.bus.$off('poiInfoFloorListen');
            this.bus.$on('poiInfoFloorListen',res=>{
                this.floor(res.floorNumber)
            })
        },

        methods:{

            close(){

                let $this = this;
                let poiMarkers = $VAR.PoiListMaker;
                for(let i =0; i<poiMarkers.length;i++){
                    let $li =poiMarkers[i];

                    if($li.item.POI_ID == this.poiInfo.poi.POI_ID){
                        $li.maker.remove();

                        $li.maker = new brtmap.Symbol.DivMarker({
                            content:'<div class="wrap"><div class="icon-box"><i class="poi-icon-' +$li.item.CATEGORY_ID+'" style="background-image: url('+$li.item.CATEGORY_ICON+')"></i></div></div>',
                            className:'filter-marker',
                            offset:[0,-10]
                        }).addTo($VAR.map).setLnglat($VAR.map.coordsToLnglat($li.item.LABEL_X,$li.item.LABEL_Y));

                        $li.maker.on('click',(res)=>{
                            event.stopPropagation();
                            this.$mapStep.poiID = $li.item.POI_ID;
                            this.bus.$emit('selectedPoint',$li.item.POI_ID);
                            this.$mapStep.type = 'selectePOI';
                            this.$BRT.$filter.enter = 'Filter';
                            this.$BRT.$options.PoiListDrawer = 0;

                        })

                    }

                }

                this.show = false;

                this.$mapStep.type = '';
                this.$mapStep.poiID = '';
                this.bus.$emit('selectedPoint','');

                // $VAR.map.easeTo({
                //     center:$VAR.map.getCenter(),
                //     zoom:$VAR.map.getBaseZoom(),
                //     duration:1000
                // });

                // this.$mapStep.type=''
            },

            // back(){//返回
            //
            //     if(this.$BRT.$active.initEnter){
            //
            //         this.$router.replace(this.$BRT.$active.initEnter);
            //         this.$BRT.$active.initEnter = '';
            //         this.$BRT.$marker.selected.empty();
            //
            //     }else{
            //         this.bus.$emit('pointFilterBack');
            //     }
            //
            // },

            showPoi(poiID){

                let $this = this,$brtmap =$this.$store.state.mapStore.brtmap,poiInfo;

                let _callback=(poiInfo)=>{


                    // console.log('poiInfo',poiInfo);

                    //检查是否有详情poi
                    let obj = '';

                    obj = _detailPoiExtend([poiInfo], this.$store.state.POI_DETAIL_DATA);

                    //检查是否有店铺活动poi
                    obj = _activityPoiExtend([poiInfo], this.$store.state.ACTIVITY_DATA);

                    //检查是否有店铺是否参加了主题活动
                    obj = _themeActivityPoiExtend([poiInfo],this.$store.state.THEME_ACTIVITY_DATA[0])

                    //类型图标
                    obj = CATEGORY_ICONExtend([poiInfo]);


                    // console.log('点位匹配值obj',obj);

                    obj = obj[0];

                    $this.poiInfo.activity = obj.activity;
                    $this.poiInfo.detail = obj.detail ? obj.detail : {TAGS:[]};

                    //拼接数据
                    // $this.poiInfo.LOGO="http://p.brtbeacon.net/test/pro-maintain/3Dplug-CRH/v2.3.2-vue/test/dist/images/poi_logo.png";
                    $this.poiInfo.LOGO = obj.detail && obj.detail.LOGO ? obj.detail.LOGO:'';
                    $this.poiInfo.slideIMG = obj.detail && obj.detail.imgUrl ? obj.detail.imgUrl : [];

                    $this.poiInfo.NAME = poiInfo.NAME ? poiInfo.NAME : poiInfo.CATEGORY_NAME ;

                    $this.poiInfo.floorName = poiInfo.FLOOR_NAME;

                    // ' ' + $this.$mapStore.plugInfo.plugInfo.name+

                    $this.poiInfo.address =
                        $this.$mapStore.plugInfo.plugInfo.address; // +' ' + poiInfo.NAME +' '+poiInfo.FLOOR_NAME


                    //经纬度拼接
                    let lnglat = $VAR.map.coordsToLnglat(poiInfo.LABEL_X,poiInfo.LABEL_Y);
                    $this.poiInfo = Object.assign({},$this.poiInfo,lnglat);
                    $this.poiInfo.CATEGORY_NAME = poiInfo.CATEGORY_NAME;

                    //营业时间拼接
                    $this.poiInfo.time = obj.detail && obj.detail.bussTStr ? obj.detail.bussTStr : '';

                    $this.poiInfo.tel = obj.detail && obj.detail.phone ? obj.detail.phone : '';

                    $this.poiInfo.praise =obj.detail && obj.detail.aptitudeList ? obj.detail.aptitudeList:[];

                    $this.poiInfo.label = obj.detail && obj.detail.TAGS ? obj.detail.TAGS : [];

                    $this.poiInfo.shopDetail = obj.detail && obj.detail.intr ? obj.detail.intr : '';

                    // $this.poiInfo.ICON = obj.CATEGORY_ICON;

                    let $callback = ()=>{
                        //活动
                        let $mainActive = [],
                            $shopActive =[];
                        if(obj.activity){   //店铺活动只有一个
                            let $endTime =0;
                            if(obj.activity.status == 0){   //进行中

                                $endTime = obj.activity.endTime - new Date().getTime();

                            }else if(obj.activity.status == 1){  //即将开始

                                $endTime = obj.activity.startTime - new Date().getTime();

                            }

                            $endTime = new Date().D_H_M($endTime);

                            if(obj.activity.status < 2){
                                $shopActive.push({
                                    type:0,
                                    name:obj.activity.title,
                                    state:obj.activity.status,
                                    endTime:$endTime,
                                    imgUrl:obj.activity.topic,
                                    num:obj.activity.count ? obj.activity.count : 0,
                                    Data:obj.activity
                                })
                            }

                        }

                        if(obj.theme_activity && obj.theme_activity.length >0){

                            obj.theme_activity.map((item)=>{

                                let $endTime =0;

                                if(item.status == 0){   //进行中

                                    $endTime = item.endTime - new Date().getTime();

                                }else{  //即将开始

                                    $endTime = item.startTime - new Date().getTime();

                                }

                                $endTime = new Date().D_H_M($endTime)


                                $mainActive.push({
                                    type:1,
                                    name:item.title,
                                    state:item.status,
                                    endTime:$endTime,
                                    imgUrl:item.topic,
                                    num:item.count,
                                    Data:item
                                })

                            });
                        }
                        let $data = [];
                        if($mainActive.length >0 && $shopActive.length>0){
                            $data = $shopActive.concat($mainActive);
                        }else if($mainActive.length>0){
                            $data = $mainActive;
                        }else {
                            $data = $shopActive;
                        }

                        $this.poiInfo.active =$data;


                        //是否需要切换楼层
                        if(poiInfo.FLOOR_NUMBER != $VAR.map.currentMapInfo.floorNumber){

                            $this.needfloor = true;

                            let $zoom = $VAR.map.getZoom(),
                                $floorId = poiInfo.FLOOR_ID;

                            $VAR.map.setFloor($floorId,()=>{
                                $VAR.map.stop().easeTo({
                                    zoom:$zoom
                                })
                            });

                        }


                        /**********筛选新增**************/
                        //还原筛选图标
                        let poiMarkers = $VAR.PoiListMaker;
                        for(let i =0; i<poiMarkers.length;i++){
                            let $li =poiMarkers[i];

                            $li.maker.show();

                            if($li.item.POI_ID == $this.LastPOI_ID){
                                $li.maker.remove();
                                $li.maker = new brtmap.Symbol.DivMarker({
                                    content:'<div class="wrap"><div class="icon-box"><i class="poi-icon-' +$li.item.CATEGORY_ID+'" style="background-image: url('+$li.item.CATEGORY_ICON+')"></i></div></div>',
                                    className:'filter-marker',
                                    offset:[0,-10]
                                }).addTo($VAR.map).setLnglat($VAR.map.coordsToLnglat($li.item.LABEL_X,$li.item.LABEL_Y))

                                $li.maker.on('click',(res)=>{

                                    event.stopPropagation();
                                    $this.$mapStep.poiID = $li.item.POI_ID;
                                    $this.bus.$emit('selectedPoint',$li.item.POI_ID);
                                    $this.$mapStep.type = 'selectePOI';
                                    $this.$BRT.$filter.enter = 'Filter';
                                    $this.$BRT.$options.PoiListDrawer = 0;

                                })
                            }
                        }


                        //计算距离
                        this.bus.$emit('getDistant',{
                            type:1,
                            point:poiInfo,
                            callback:(data)=>{
                                $this.poiInfo.distance = data ? data.distance : null;
                            }
                        });



                        //替换图标
                        $VAR.PoiListMaker.filter((item,index,slef)=>{

                            if(item.item.POI_ID == poiInfo.POI_ID){

                                item.maker.empty();

                                this.LastPOI_ID =  poiInfo.POI_ID;
                            }

                            return item.item.POI_ID == poiInfo.POI_ID;
                        })

                        //poi选中插标
                        let lngLat = $VAR.map.coordsToLnglat(poiInfo.LABEL_X,poiInfo.LABEL_Y);

                        $brtmap.$marker.selected.setContent('<div class="wrap">' +
                            '<div class="border"></div>' +
                            '<div class="bg"></div>' +
                            '<i class="poi-icon-'+ poiInfo.CATEGORY_ID +'" style="background-image: url('+$this.poiInfo.ICON+')"></i>'+
                            '</div>').setLnglat(lngLat);

                        //地图中心点设置
                        $VAR.map.easeTo({
                            center:lngLat,
                            // zoom:JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.navigation).defaultRank ? JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.navigation).defaultRank : 19
                        });


                        $this.poiInfo.poi = poiInfo;

                        //保存选中值
                        $brtmap.$selecte.point = $this.poiInfo;

                        //是否是筛选点位
                        if($brtmap.$filter.open){$this.bus.$emit('pointFilter',$this.poiInfo)}

                        $this.show = true;

                        setTimeout(()=>{$this.$message.load(false)},0)
                    }

                    //判断图标是否存在
                    $this.bus.$emit('CATEGORYID_ICON_TRUE',{
                        ICON:obj.CATEGORY_ICON,
                        callback:(res)=>{

                            if(res){
                                $this.poiInfo.ICON = res;
                            }else{
                                $this.poiInfo.ICON = obj.CATEGORY_ICON;
                            }

                            $callback && $callback();
                        }
                    })



                }


                if(poiID !='location'){

                    let $query = (type,value,callback)=>{

                        $VAR.brtmapSearch.query({
                            type:type,  //'poiid'
                            value:value
                        }, function (result) {
                            callback && callback(result);
                        })

                    };

                    let callback = ()=>{
                        $query('poiid',poiID,result=>{

                            result = result.filter((item,index,self)=>{
                                return item.POI_ID == poiID
                            });


                            //拼接号馆
                            if(result[0] && result[0].REGION && result[0].NAME && result[0].NAME.indexOf(result[0].REGION) === -1){
                                result[0].NAME = result[0].REGION  + result[0].NAME;
                            }

                            poiInfo = result[0];

                            if(poiInfo){

                                _callback && _callback(poiInfo);

                                /*

                                if(poiInfo.NAME.indexOf('号馆') == -1 && poiInfo.ZONE_ID){
                                    $query('poiid',poiInfo.ZONE_ID,res=>{

                                        if(res.length  && res[0].NAME.indexOf('号馆')> -1){
                                            poiInfo.NAME = res[0].NAME + poiInfo.NAME;
                                        }

                                        _callback && _callback(poiInfo);
                                    })

                                }else{
                                    _callback && _callback(poiInfo);
                                }

                                 */

                            }

                            else{

                                // $this.$mapStep.type='';  //防止查询不到
                                $this.show = false;
                                $this.$mapStep.poiID='';
                                $this.bus.$emit('selectedPoint');
                            }
                        });
                    }

                    if(!this.$mapEventManger.mapQueryStatus){
                        this.$mapEventManger.mapQueryEvents.push(callback)
                    }else{
                        callback()
                    }


                }else{  //分享当前点位

                    let lngLat =  $VAR.map.coordsToLnglat($brtmap.$urlParam.share.LABEL_X,$brtmap.$urlParam.share.LABEL_Y),
                        poiInfo = getPoiInfo($brtmap,$VAR.map.project(lngLat)),
                        $floor = $VAR.map.getFloorInfoByIndex($brtmap.$urlParam.share.FLOOR_NUMBER);

                    if(poiInfo){

                        //数据结构
                        this.showPoi(poiInfo.POI_ID)

                    }else{
                        poiInfo={
                            CATEGORY_ICON:'./images/selecte_null.png',
                            CATEGORY_ID:'',
                            CATEGORY_NAME:'无名地址',
                            NAME:'无名地址',
                            LABEL_X:$brtmap.$urlParam.share.LABEL_X,
                            LABEL_Y:$brtmap.$urlParam.share.LABEL_Y,
                            FLOOR_ID:$floor.mapID,
                            FLOOR_NUMBER:$floor.floorNumber,
                            FLOOR_NAME:$floor.floorName,
                            POI_ID:'location'
                        }



                        _callback && _callback(poiInfo);
                    }

                }




                //改变详情值
                // $this.poiInfo.poi= poiInfo;
                // $this.$store.state.mapStore.brtmap.$selecte.point=$this.poiInfo;

            },

            getRoute(){

                let $this = this;

                //清除分享限制
                this.$BRT.$urlParam.share.status=false;
                this.$BRT.$urlParam.share.poiId = '';

                for(let i =0; i<$VAR.PoiListMaker.length;i++){
                    let $li =$VAR.PoiListMaker[i];
                    $li.maker.hide();
                }


                this.$BRT.$marker.selected.empty();
                this.$BRT.$selecte.endPoint = this.poiInfo.poi;

                this.$mapStep.type ='planRoute';

                if(this.$BRT.$locate.point){

                    this.bus.$emit('startAndEnd',{type:2});

                }else{

                    this.$BRT.$route.selectType.type ='location';
                    this.$BRT.$selecte.startPoint = '';
                    // this.bus.$emit('openLocation');

                }
            },

            sharePoint(){

                this.bus.$emit('shareCallback',{status:1,shareInfo:this.poiInfo.poi})

            },

            goDetail(){
                this.$mapStep.type='poiDetail';
                this.$mapStep.poiID = this.poiInfo.poi.POI_ID;
                this.$BRT.$urlParam.share.status=false;
                this.$BRT.$urlParam.share.poiId = '';
            },

            floor(v1,v2){

                //导航、规划路线筛选图标隐藏
                if(this.$mapStep.type=='toNAVING' || this.$mapStep.type=='planRoute'){

                    for(let i =0; i<$VAR.PoiListMaker.length;i++){
                        let $li =  $VAR.PoiListMaker[i];
                        $li.maker.hide();
                    }

                }

                if(!this.needfloor && !!this.poiInfo.poi){   //其他接入需要切换楼层(影响较大大，小心修改)

                    //清空
                    if(this.poiInfo.poi.FLOOR_NUMBER != $VAR.map.currentMapInfo.floorNumber){

                        let $lastStep = window.sessionStorage.getItem('lastStep');

                        if((this.$mapStep.type=='selectePOI' && $lastStep !='planRoute' && $lastStep !='toFilter') || this.$BRT.$urlParam.share.status){

                            this.$mapStep.type='';

                        }else{

                            //特殊清空
                            if(this.$mapStep.type=='selectePOI' && $lastStep =='planRoute' && !$VAR.PoiListMaker.length){this.$mapStep.type='';}

                            this.$BRT.$marker.selected.empty();
                            this.show =false;

                        }

                    }

                    if(this.poiInfo.poi.FLOOR_NUMBER == $VAR.map.currentMapInfo.floorNumber && this.$BRT.$urlParam.share.status){//分享
                        this.$mapStep.type='selectePOI';
                        this.$mapStep.POI_ID = this.$BRT.$urlParam.share.poiId;
                        this.showPoi(this.$BRT.$urlParam.share.poiId);

                    }

                    // let $lastStep = window.sessionStorage.getItem('lastStep');
                    // $lastStep == 'planRoute' ? window.sessionStorage.setItem('lastStep','selectePOI'): window.sessionStorage.setItem('lastStep','change');
                    // this.$mapStep.type=='selectePOI' && $lastStep !='planRoute' ? this.$mapStep.type='' : ''

                }

                else{

                    this.needfloor = false;
                }

            }

        },
        watch:{

            // point(v1,v2){
            //
            //     v1 ? this.showPoi(v1) : this.$BRT.$marker.selected.empty();
            //
            // },

        },


        mounted(){
            //防止从其他页面初次进入不执行监听问题
           if(this.$BRT.$mapStep.type == 'selectePOI'){this.showPoi(this.$mapStep.poiID);}

           //其他页面进入 地图未加载情况
           if(this.$BRT.$urlParam.NomapReady == 1){
               this.$mapStep.type='selectePOI';
               this.showPoi(this.$mapStep.poiID);
               this.$BRT.$urlParam.NomapReady = '';
           }
        }
    }



</script>

<style lang="less">
 @import "PoiInfoModule.less";
</style>
